import { useEffect, type FC } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AppForm, FormCheckbox } from "@/shared/Components";
import type { MenuFilterFormValues } from "./model";
import styles from "./styles.module.scss";
import { menuFilterSchema } from "./model";

export type MenuFilter = { defaultChecked?: boolean; value: string; label: string };

export type MenuFilterProps = {
  filters: MenuFilter[];
  onChange: (selected: string[]) => void;
};

export const MenuFilter: FC<MenuFilterProps> = ({ filters, onChange }) => {
  const formApi = useForm({
    resolver: yupResolver(menuFilterSchema),
    defaultValues: {
      filters: filters.map((item) => ({
        value: item.value,
        selected: item.defaultChecked ?? false,
      })),
    },
  });

  const submitHandler = (data: MenuFilterFormValues) => {
    onChange(
      data.filters?.flatMap((item) => {
        if (item.selected) return item.value;
        return [];
      }) ?? [],
    );
  };

  useEffect(() => {
    const subscription = formApi.watch(() => formApi.handleSubmit(submitHandler)());
    return () => subscription.unsubscribe();
  }, [formApi.handleSubmit, formApi.watch]);

  return (
    <AppForm formApi={formApi} onSubmit={submitHandler}>
      <div className={styles.root}>
        {filters?.map((item, index) => {
          return (
            <div className={styles.box} key={`${item.value}`}>
              <FormCheckbox
                className={styles.checkbox}
                name={`filters.${index}.selected`}
                defaultChecked={item.defaultChecked}
              >
                {item.label}
              </FormCheckbox>
            </div>
          );
        })}
      </div>
    </AppForm>
  );
};
